<template>
  <div class="userPositionMapping h100">
    <!-- <h1>This is an userPositionMapping page</h1> -->
    <el-card>
      <el-form ref="searchListRef" :model="searchList" :inline="true">
        <el-form-item label="年份" prop="year">
          <el-date-picker v-model="searchList.year" type="year" value-format="yyyy" placeholder="请选择年份"></el-date-picker>
        </el-form-item>
        <el-form-item label="季度" prop="quarter">
          <el-select v-model="searchList.quarter" placeholder="请选择季度">
            <el-option label="Q1" value="Q1"></el-option>
            <el-option label="Q2" value="Q2"></el-option>
            <el-option label="Q3" value="Q3"></el-option>
            <el-option label="Q4" value="Q4"></el-option>
            <el-option label="Yearly" value="Yearly"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search()">搜 索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetSearch()" plain>清 空</el-button>
        </el-form-item>
      </el-form>
      <el-upload v-if="roles.indexOf('Admin')>-1 || roles.indexOf('SIP')>-1" class="uploadClass" ref="uploadRef" :multiple='false'
        action
        :http-request="upload"
        :data= searchList
        :show-file-list='false'
        :before-upload="beforeUpload">
        <el-button type="primary">文件上传</el-button>
        </el-upload>
      <el-table style="margin-top:20px" :data="data" border header-cell-class-name="headerStyle" cell-class-name="cellStyle">
        <el-table-column v-for="(item, index) in columns" :key="index" :prop="item.prop" :label="item.label"></el-table-column>
        <el-table-column label="文件下载">
          <template slot-scope="scope">
            <template>
              <i class="el-icon-download downloadIcon" @click="download(scope.row)"></i>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="" label="附件上传状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.file!==null?'success':'danger'" disable-transitions>{{scope.row.file!==null?'已上传':'未上传'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="" label="附件上传" v-if="roles.indexOf('Admin')>-1 || roles.indexOf('SIP')>-1">
          <template slot-scope="scope">
            <el-upload ref="uploadRef" :multiple='false'
            action
            :http-request="attachmentUpload"
            :data= {relationId:scope.row.id}
            :show-file-list='false'>
              <i class="el-icon-upload2 downloadIcon"></i>
            </el-upload>
          </template>
        </el-table-column>
        <el-table-column prop="" label="附件下载">
          <template slot-scope="scope">
            <i class="el-icon-download downloadIcon" @click="attachmentDownload(scope.row)"></i>
          </template>
        </el-table-column>
        <el-table-column prop="file.createUser" label="附件上传人"></el-table-column>
        <!-- <el-table-column prop="" label="确认状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.confirmStatus==='Y'?'success':'danger'" disable-transitions>{{scope.row.confirmStatus==='Y'?'已确认':'未确认'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="roles.indexOf('Admin')>-1 || roles.indexOf('HR')>-1" label="确认">
          <template slot-scope="scope"> -->
            <!-- <el-button :type="scope.row.confirmStatus==='Y'?'primary':''" size="mini" @click="confirm(scope.row)">确认</el-button> -->
            <!-- <el-button type="primary" size="mini" @click="confirm(scope.row)">确认</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="confirmUser" label="确认人"></el-table-column> -->
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'userPositionMapping',
  data () {
    return {
      // 用户信息
      userInfo: '',
      roles: [],
      searchList: {
        year: null,
        quarter: null
      },
      data: [],
      columns: [
        {
          prop: 'year',
          label: '年份'
        },
        {
          prop: 'quarter',
          label: '季度'
        },
        {
          prop: 'createUser',
          label: '上传人'
        },
        {
          prop: 'createTime',
          label: '上传时间'
        }
      ]
    }
  },
  created () {
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    if (this.userInfo !== null) {
      let arr = this.userInfo.roles
      let roles = []
      if (arr != null && arr.length > 0) {
        arr.forEach(ele => {
          roles.push(ele.roleName)
        })
      }
      this.roles = roles
    }
  },
  mounted () {
    this.getUserPositionMappingList()
  },
  methods: {
    // 人岗关系列表
    getUserPositionMappingList (message) {
      this.data = []
      this.$http.post(this.API.userDataUploadList, this.searchList).then((res) => {
        let data = res.data
        if (data.code === 200) {
          this.data = data.data
          // 处理筛选项
          if (message) {
            this.$message.success('搜索成功！')
          }
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // year quarter筛选人岗列表
    search () {
      this.getUserPositionMappingList(true)
    },
    // 重置
    resetSearch () {
      this.searchList = {
        year: null,
        quarter: null
      }
      this.getUserPositionMappingList()
    },
    // 上传前校验
    beforeUpload (file) {
      // console.log(file)
      // file.name-文件名字
      // file.size-文件大小
      // file.type-文件类型
      // 上传前格式与大小校验
      if (this.searchList.year !== null && this.searchList.quarter !== null) {
        const isExcel = file.type === 'application/vnd.ms-excel' || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        // const isLt2M = file.size / 1024 / 1024 < 2
        if (!isExcel) {
          this.$message.error('上传模板只能是Excel格式!')
        }
        // if (!isLt2M) {
        //   this.$message.error('上传模板大小不能超过 2MB!')
        // }
        // return isJPG && isLt2M
        return isExcel
      } else {
        this.$message.error('请选择年份和季度！')
        return false
      }
    },
    // 上传
    upload (e) {
      // console.log(e)
      let formData = new FormData()
      formData.append('year', e.data.year)
      formData.append('quarter', e.data.quarter)
      formData.append('file', e.file)
      this.$http.post(this.API.userUpload, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
        // console.log(res)
        if (res.status === 200) {
          let data = res.data
          if (data.code === 200) {
            this.$message.success('上传成功！')
            // 更新岗关系列表
            this.getUserPositionMappingList()
          } else {
            this.$message.error(data.msg + ' --- 请重新上传！')
            // this.$message.error('请下载模板，查看具体原因，重新上传模板！')
          }
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 下载
    download (row) {
      this.$http.get(this.API.userExport, { params: { year: row.year, quarter: row.quarter }, responseType: 'blob' }).then(res => {
        // console.log(res)
        if (res.status === 200) {
          // console.log(res)
          let blob = new Blob([res.data], { type: res.data.type })
          let downloadElement = document.createElement('a')
          let href = window.URL.createObjectURL(blob) // 创建下载的链接
          downloadElement.href = href
          downloadElement.download = '人岗关系' + '-' + row.year + '-' + row.quarter + '-' + '.xls' // 下载后文件名
          document.body.appendChild(downloadElement) // 添加元素
          downloadElement.click() // 点击下载
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
          this.$message.success('下载成功！')
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 附件上传
    attachmentUpload (e) {
      // console.log(e)
      let formData = new FormData()
      formData.append('relationId', e.data.relationId)
      formData.append('businessType', 'userPositionMapping')
      formData.append('file', e.file)
      this.$http.post(this.API.fileUpload, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
        // console.log(res)
        if (res.status === 200) {
          let data = res.data
          if (data.code === 200) {
            this.$message.success('上传成功！')
            // 更新人岗关系列表
            this.getUserPositionMappingList()
          } else {
            this.$message.error(data.msg + ' --- 请重新上传！')
            // this.$message.error('请下载模板，查看具体原因，重新上传模板！')
          }
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 附件下载
    attachmentDownload (row) {
      if (row.file !== null) {
        this.$http.get(this.API.fileDownload, { params: { relationId: row.id, businessType: 'userPositionMapping' }, responseType: 'blob' }).then(res => {
          // console.log(res)
          if (res.status === 200) {
          // console.log(res)
            let blob = new Blob([res.data], { type: res.data.type })
            let downloadElement = document.createElement('a')
            let href = window.URL.createObjectURL(blob) // 创建下载的链接
            downloadElement.href = href
            downloadElement.download = row.file.fileName // 下载后文件名
            document.body.appendChild(downloadElement) // 添加元素
            downloadElement.click() // 点击下载
            document.body.removeChild(downloadElement) // 下载完成移除元素
            window.URL.revokeObjectURL(href) // 释放掉blob对象
            this.$message.success('下载成功！')
          } else {
            this.$message.error('接口调用失败！')
          }
        })
      } else {
        this.$message.error('请上传附件！')
      }
    },
    // 确认--没用到
    confirm (row) {
      if (row.file !== null) {
        this.$http.get(this.API.userDataUploadConfirm, { params: { id: row.id } }).then(res => {
          // console.log(res)
          this.$message.success('确认成功！')
          // 更新人岗关系列表
          this.getUserPositionMappingList()
        })
      } else {
        this.$message.error('请上传附件！')
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>
